import { useEffect } from 'react';

/* Also styled in supreme-header, search-form, library-switch, nav-toggle-button and `_colors.css`. */
export const IMMERSIVE_HEADER_CLASS = 'header-immersive';

/** Header is transparent at the top of the page, fading back in over `fadeDistance` px of scroll. */
export function useImmersiveHeader(fadeDistance = 160) {
    useEffect(() => {
        const { body } = document;
        let frame = 0;
        let opacity = '';

        const update = () => {
            frame = 0;
            const next = `${Math.min(window.scrollY / fadeDistance, 1)}`;
            // Writing to body restyles the whole page, so skip unchanged values.
            if (next === opacity) return;
            opacity = next;
            body.style.setProperty('--header-immersive-opacity', opacity);
        };

        const onScroll = () => {
            if (!frame) frame = requestAnimationFrame(update);
        };

        body.classList.add(IMMERSIVE_HEADER_CLASS);
        update();
        window.addEventListener('scroll', onScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', onScroll);
            cancelAnimationFrame(frame);
            body.classList.remove(IMMERSIVE_HEADER_CLASS);
            body.style.removeProperty('--header-immersive-opacity');
        };
    }, [fadeDistance]);
}

export default useImmersiveHeader;
